"use client";

import { useEffect } from "react";
import logger from "@/lib/logger.mjs";

function setupGlobalErrorHandlers() {
  const createMockReq = () => ({
    url: window.location.pathname,
    method: "GET",
    headers: {
      "user-agent": window.navigator.userAgent,
      host: window.location.host,
      "x-forwarded-for": "",
    },
  });

  window.addEventListener("unhandledrejection", (event) => {
    const mockReq = createMockReq();
    // Create a proper error object for unhandled promise rejections
    const errorMessage =
      event.reason?.message ||
      event.reason?.toString() ||
      "Unhandled Promise Rejection";
    const errorToLog = new Error(errorMessage);
    errorToLog.name = "UnhandledPromiseRejection";
    errorToLog.originalError = event.reason;
    errorToLog.component = "GlobalErrorHandler";

    logger.error(errorToLog, {
      type: "unhandledrejection",
      component: "GlobalErrorHandler",
      action: "handlePromiseRejection",
      url: window.location.href,
      ...mockReq,
    });
  });

  window.addEventListener("error", (event) => {
    const mockReq = createMockReq();
    // Create a proper error object for uncaught errors
    const errorToLog = event.error || new Error(event.message);
    errorToLog.name = "UncaughtError";
    errorToLog.source = event.filename;
    errorToLog.line = event.lineno;
    errorToLog.column = event.colno;
    errorToLog.component = "GlobalErrorHandler";

    logger.error(errorToLog, {
      type: "uncaughterror",
      component: "GlobalErrorHandler",
      action: "handleUncaughtError",
      source: event.filename,
      line: event.lineno,
      column: event.colno,
      url: window.location.href,
      ...mockReq,
    });
  });
}

export function Providers({ children }) {
  useEffect(() => {
    setupGlobalErrorHandlers();
  }, []);

  return <>{children}</>;
}
